
import { useAdminStatus } from "./admin/useAdminStatus";
import { useAdminStats } from "./admin/useAdminStats";
import { useCancellationRequests } from "./admin/useCancellationRequests";
import { useAdminData } from "./admin/useAdminData";

export const useAdminDashboard = () => {
  const { isAdmin, loading } = useAdminStatus();
  const stats = useAdminStats(isAdmin);
  const { cancellationRequests, handleCancellationAction } = useCancellationRequests(isAdmin);
  const { recentBookings, parkingSpots, users } = useAdminData(isAdmin);

  return {
    isAdmin,
    loading,
    stats,
    cancellationRequests,
    recentBookings,
    parkingSpots,
    users,
    handleCancellationAction
  };
};
